Vue.component('page-customer-profile', {

    data: function () {
        return {
            customer: apr.customer,
            current_password: null,
            password: null,
            password_confirmation: null,
            newsletter: null,
            sms: null,
            successMessage: null,
            errorMessage: null,
        }
    },

    mounted() {
        this.initModalForm()
    },

    watch: {},

    methods: {
        initModalForm(){
            let self = this
            let requesting = false
            let $form = $(this.$el).find("form")

            $form.parsley().on("form:submit", function () {
                $form.find("input").each(function () {
                    $(this).parsley().removeError('custom-error');
                });
                return false;

            }).on('form:success', function (formInstance) {
                if (requesting) {
                    return false;
                }
                requesting = true;
                self.successMessage = null
                self.errorMessage = null

                self.$http.put('/customer/profile', self.getFormData()).then(response => {
                    self.successMessage = response.data.message;
                    self.current_password = null;
                    self.password = null;
                    self.password_confirmation = null;

                    requesting = false;
                    self.scrollTop();

                }, response => {
                    let errors = response.body

                    for (var errorName in errors) {
                        if (errorName == 'errors') {
                            self.errorMessage = self.filters.formatMessage(errors[errorName])
                        }

                        let $field = $form.find(`input[name="${errorName}"]`);

                        if ($field.length) {
                            $field.parsley().addError('custom-error', {message: errors[errorName]});
                        }
                    }

                    requesting = false;
                    self.scrollTop();
                });

                return false;
            });
        },

        getFormData() {
            return {
                email: this.customer.email,
                firstname: this.customer.firstname,
                lastname: this.customer.lastname,
                zipcode: this.customer.zipcode,
                mobile: this.customer.mobile,
                phone: this.customer.phone,

                current_password: this.current_password,
                password: this.password,
                password_confirmation: this.password_confirmation,
                newsletter: this.customer.newsletter,
                sms: this.customer.sms,
            }
        },

        scrollTop() {
            $('html, body').animate({scrollTop: 0}, 500);
        },
    }
});
